import React, { useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";


// core components
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import HeaderLinks from "components/Header/HeaderLinks.js";
import HeaderLinksCommunity from "components/Header/HeaderLinksCommunity.js";

import Footer from "components/Footer/Footer.js";
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import { Link } from "react-router-dom";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function Discussionlatest(props) {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div className="inner_header">
      <Header
        fixed
        color="transparent"
        routes={dashboardRoutes}
        brand={<>
          <div className="light_logo"><Link to="/">
            <img src={require("../assets/images/logo.png")} alt="logo" className="img-fluid"/></Link></div>
            <div className="dark_logo"><Link to="/">
            <img src={require("../assets/images/dark-theme-logo.png")} alt="logo" className="img-fluid"/></Link></div>
            </>}
        rightLinks={<HeaderLinksCommunity />}
        changeColorOnScroll={{
          height: 50,
          color: "dark"
        }}
        {...rest}
      />
      <ScrollToTopOnMount/>
      <div className={classes.pageHeader + " inner_pageheader"}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className="d-flex align-items-center">
              <button className="btn create_btn">Go Back</button>              
              </div>
            </GridItem>
          </GridContainer>
        </div>
        <div className="container mt-4">
<GridContainer>
<GridItem xs={12} sm={12} md={12}>                                       

<div className="mt-0">
               

<div className="tab-pane fade show active" id="latest" role="tabpanel" aria-labelledby="following-tab">
<div className="proposal_panel_overall">                 
                 
<div className="table-responsive">
<table className="table table_style_1">
<thead>
    <tr>
        <th> 
         Category
  </th>
        <th className="text-right"> Replies </th>
        <th className="text-right"> Views </th>
        <th className="text-right"> Activity </th>

    </tr>
</thead> 
<tbody>
    <tr>
        <td>          
        <Link to="/discussion-detail"><p className="cat_title">About the General Community category</p></Link>
        <p className="cat_desc mb-0">General community discussion topics and posts</p>      
         </td>
       
        <td className="text-right"> 133 </td>
        <td className="text-right"> 5.9k </td>
        <td className="text-right"> 20 days, 23 hours, 27 minutes </td>

    </tr> 
    <tr>
        <td>          
        <Link to="/discussion-detail"><p className="cat_title">How long should I wait?</p></Link>
        <p className="cat_desc mb-0">Lets share links to the best “NFT” Tools,Platforms,Communities & Resources</p>        
         </td>
        
        <td className="text-right"> 2133 </td>
        <td className="text-right"> 1.7k </td>
        <td className="text-right"> 30m </td>

    </tr> 
    <tr>
        <td>          
        <Link to="/discussion-detail"><p className="cat_title">About the General Community category</p></Link>
        <p className="cat_desc mb-0">General community discussion topics and posts</p>        

         </td>
        
        <td className="text-right"> 89 </td>
        <td className="text-right"> 1.2k </td>
        <td className="text-right"> 20h </td>

    </tr> 

    <tr>
        <td>          
        <Link to="/discussion-detail"><p className="cat_title">How long should I wait?</p></Link>
        <p className="cat_desc mb-0">Lets share links to the best “NFT” Tools,Platforms,Communities & Resources</p>       

         </td>
       
        <td className="text-right"> 541 </td>
        <td className="text-right"> 719 </td>
        <td className="text-right"> 20 days, 23 hours, 27 minutes </td>

    </tr> 
</tbody>
</table>
</div>

</div>
</div>

</div>
</GridItem>
</GridContainer>
</div>
      </div>
      <Footer/>
    </div>
  );
}
